import { motion } from 'framer-motion'
import Button from './Button'
import { duration, stagger } from '../lib/motion'

// Sits between Pricing and GrowthPlans (see AppRoutes.jsx / GetAWebsite.jsx)
// on purpose: it's the bridge between "what's included in the one-time
// build" and "what's ongoing via Growth Plans." Without this, the
// discoverability story is split across two sections with no line drawn
// between them, and Growth/Scale's new SEO-inclusion copy (content.js)
// could read as if it makes Growth Plans' SEO features redundant. This
// section exists specifically to keep those two claims from colliding —
// it's not just a repeat of the pricing-card copy.
const POINTS = [
  {
    label: 'Included in every Growth & Scale build',
    title: 'Foundational SEO',
    copy: 'Keyword-informed structure, page content and on-page optimization — done once, at launch, so search engines can actually read and rank your site from day one.',
  },
  {
    label: 'Ongoing, via Growth Plans',
    title: 'Active content strategy',
    copy: "Rankings compound over time, not at launch. Monthly SEO content and keyword research keep working after the site goes live — that's what Growth Plans are for.",
  },
]

export default function Discoverability() {
  return (
    <section className="py-24 border-t" style={{ borderColor: 'var(--border)' }}>
      <div className="container-bw max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: duration.base }}
          className="mb-14"
        >
          <p className="eyebrow mb-4">Discoverability</p>
          <h2 className="font-display text-3xl md:text-4xl mb-4" style={{ color: 'var(--text-primary)' }}>
            A website that converts is only half the job. It also has to be found.
          </h2>
          <p style={{ color: 'var(--text-secondary)' }}>
            We don't just design for the visitor already on your site — we build so search
            engines can find it in the first place.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: duration.base, delay: i * stagger.base }}
              className="rounded-2xl border p-6"
              style={{ borderColor: 'var(--border)', background: 'var(--card)' }}
            >
              <p className="text-xs uppercase tracking-wide mb-3" style={{ color: 'var(--text-muted)' }}>
                {p.label}
              </p>
              <h3 className="font-display text-lg mb-2" style={{ color: 'var(--text-primary)' }}>
                {p.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                {p.copy}
              </p>
            </motion.div>
          ))}
        </div>

        <Button href="#care-plans" variant="secondary">
          See BWC Care Plans
        </Button>
      </div>
    </section>
  )
}
